import {
  CurrencyRupeeIcon,
  CurrencyDollarIcon,
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  CreditCardIcon,
} from '@heroicons/react/24/outline';
import { formatDate as formatDateUtil, formatTime as formatTimeUtil } from './dateUtils';

export const formatDate = (timestamp) => {
  return formatDateUtil(timestamp);
};

export const formatTime = (timestamp) => {
  return formatTimeUtil(timestamp);
};

const getLocaleForCurrency = (currency) => {
  switch (currency?.toUpperCase()) {
    case 'USD':
      return 'en-US';
    default:
      return 'en-IN';
  }
};

export const formatAmount = (amount, currency = 'INR') => {
  if (amount === undefined || amount === null || amount === '') return '—';

  const numericAmount = Number(amount);
  if (Number.isNaN(numericAmount)) return '—';

  try {
    return new Intl.NumberFormat(getLocaleForCurrency(currency), {
      style: 'currency',
      currency: currency || 'INR',
      minimumFractionDigits: 2,
    }).format(numericAmount);
  } catch (error) {
    return `${getCurrencySymbol(currency)}${numericAmount.toFixed(2)}`;
  }
};

export const getCurrencyIcon = (currency, className = 'h-4 w-4') => {
  if (currency?.toUpperCase() === 'USD') {
    return <CurrencyDollarIcon className={className} />;
  }
  return <CurrencyRupeeIcon className={className} />;
};

export const getCurrencySymbol = (currency) => {
  if (currency?.toUpperCase() === 'USD') {
    return '$';
  }
  return '₹';
};

export const getCurrencyLabel = (currency) => {
  if (currency?.toUpperCase() === 'USD') {
    return 'USD (US Dollar)';
  }
  return 'INR (Indian Rupee)';
};

export const getStatusIcon = (linkStatus) => {
  switch (linkStatus) {
    case 'PAID':
      return <CheckCircleIcon className="h-4 w-4 text-emerald-500" />;
    case 'ACTIVE':
      return <CheckCircleIcon className="h-4 w-4 text-green-500" />;
    case 'CANCELLED':
      return <XCircleIcon className="h-4 w-4 text-red-500" />;
    case 'EXPIRED':
      return <ClockIcon className="h-4 w-4 text-yellow-500" />;
    default:
      return <ExclamationTriangleIcon className="h-4 w-4 text-gray-500" />;
  }
};

export const getStatusColor = (linkStatus) => {
  switch (linkStatus) {
    case 'PAID':
      return 'text-emerald-600 bg-emerald-50 ring-emerald-600/20 dark:text-emerald-400 dark:bg-emerald-900/20';
    case 'ACTIVE':
      return 'text-green-600 bg-green-50 ring-green-600/20 dark:text-green-400 dark:bg-green-900/20';
    case 'CANCELLED':
      return 'text-red-600 bg-red-50 ring-red-600/20 dark:text-red-400 dark:bg-red-900/20';
    case 'EXPIRED':
      return 'text-yellow-600 bg-yellow-50 ring-yellow-600/20 dark:text-yellow-400 dark:bg-yellow-900/20';
    default:
      return 'text-gray-600 bg-gray-50 ring-gray-600/20 dark:text-gray-400 dark:bg-gray-900/20';
  }
};

export const getStatusLabel = (linkStatus) => {
  return linkStatus.charAt(0).toUpperCase() + linkStatus.slice(1).toLowerCase();
};

export const getGatewayIcon = (gatewayName) => {
  switch (gatewayName?.toLowerCase()) {
    case 'cashfree':
      return <CurrencyRupeeIcon className="h-4 w-4" />;
    default:
      return <CreditCardIcon className="h-4 w-4" />;
  }
};
